import { ExerciseService, MainExerciseDto, MainExerciseLightDto } from "@domain/exercise/exercise-service";
import { ProgramContent } from "@domain/program/program";
import { DayIndex, ProgramDays } from "@domain/program/program-days";

interface SessionDto {
	exercises: MainExerciseDto[];
}

export interface ProgramContentDto {
	days: Record<string, SessionDto>;
	name: string;
}

interface SessionLightDto {
	exercises: MainExerciseLightDto[];
}

export interface ProgramLightContentDto {
	days: Record<string, SessionLightDto>;
	name: string;
}

export function getProgramLightContentDtoFromProgramContent(programContent: ProgramContent): ProgramLightContentDto {
	return {
		name: programContent.name,
		days: Object.fromEntries(
			programContent.days.map(([dayIndex, session]) => [
				DayIndex[dayIndex],
				{
					exercises: session.exercises.map(exercise => ExerciseService.dtoFromExercise(exercise)),
				},
			]),
		),
	};
}

export function getProgramContentFromDto(programContentDto: ProgramContentDto): ProgramContent {
	return {
		name: programContentDto.name,
		days: new ProgramDays(
			Object.entries(programContentDto.days).map(([dayIndex, session]) => [
				DayIndex[dayIndex as keyof typeof DayIndex],
				{
					exercises: session.exercises.map(exercise => ExerciseService.exerciseFromDto(exercise)),
				},
			]),
		),
	};
}
